<div
  data-test="error-message"
  class="df-error-input"
  [ngClass]="{ 'df-error-input--show': show }"
>
  {{ getErrorMessage() }}
</div>
